import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center text-center px-4 py-24 md:py-32 bg-background-50">
      <span className="font-label text-7xl md:text-9xl font-semibold text-primary-100 select-none">404</span>
      <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-6">页面走丢了</h1>
      <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-md">
        你访问的页面不存在或链接已失效。可以返回首页，或去浏览夏目彩春的影视作品与最新资讯。
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          返回首页
        </Link>
        <Link
          to="/category"
          className="px-6 py-3 rounded-md border border-background-300 text-foreground-700 text-sm hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          浏览影视作品
        </Link>
      </div>
    </div>
  );
}